module.exports = __webpack_public_path__ + "assets/img/no_question_tips.66f62a69.png";